// extracted by mini-css-extract-plugin
module.exports = {"IndustryLeadingA":"IndustryLeadingA_IndustryLeadingA__En0oK"};